/**
 * Widths of the filter row V1 (L3 Overview) and V2 Logs share. Only the search
 * field is flexible; the rest keep their width whatever the Time range says, so
 * the five controls stay on one line at ~1220 px of content and, below that,
 * wrap field by field instead of leaving one stretched across the card.
 */
export const FILTER_ROW_INSTANCE_WIDTH = "w-full sm:w-[220px]";
export const FILTER_ROW_SEVERITY_WIDTH = "w-full sm:w-[150px]";
export const FILTER_ROW_SEARCH_CLASS = "flex flex-col flex-1 min-w-[180px]";
export const FILTER_ROW_EXCLUDE_CLASS = "w-full sm:w-[220px] shrink-0";
